module.exports = __webpack_public_path__ + "static/mimicoHero-1ff2b2c2f7c1232748d1f7d9021da927.jpg";